<template>
  <div class="card-form">
    <form @submit.prevent="checkForm" class="card-form-wrapper">
      <H1>Login</H1>
      <TextInput
        v-model="email"
        name="email"
        label="Email"
        type="email"
        :error="errors['email']"
        @input="removeErrorMessage('email', $event)"
      />
      <TextInput
        v-model="password"
        name="password"
        label="Password"
        type="password"
        :error="errors['password']"
        @input="removeErrorMessage('password', $event)"
      />
      <p class="error" v-if="error">{{ error_message }}</p>
      <div class="card-form-cta"> 
        <a @click="redirectForgot">Forgot Password?</a>
        <Button class="red">Login</Button>
      </div>
    </form>
  </div>
</template>

<script>
import { H1, TextInput, Button } from "../style";
import { mapActions } from "vuex";
import { AUTH_LOGIN } from "../store/types";
import moment from "moment-timezone";
export default {
  name: "Login",
  components: {
    H1,
    TextInput,
    Button
  },
  data() {
    return {
      email: "",
      password: "",
      timezone: moment.tz.guess(),
      errors: {
        email: "",
        password: ""
      },
      error: false,
      error_message: ""
    };
  },
  mounted() {
    if (localStorage.getItem("token_expired")) {
      this.error = true;
      this.error_message = "Your session has expired.";

      localStorage.removeItem("token_expired");
    }
  },
  methods: {
    ...mapActions({
      authLogin: AUTH_LOGIN
    }),
    checkForm() {
      let preventSubmit = false;

      if (this.email.trim().length == 0) {
        preventSubmit = true;
        this.errors["email"] = "Email is required";
      }

      if (this.password.trim().length == 0) {
        preventSubmit = true;
        this.errors["password"] = "Password is required";
      }

      if (!preventSubmit) {
        this.submitForm();
      }
    },
    removeErrorMessage(field, value) {
      if (value.trim().length) {
        this.errors[field] = "";
      }
    },
    submitForm() {
      this.authLogin({
        email: this.email,
        password: this.password,
        timezone: this.timezone
      })
        .then(() => {
          this.$router.push("/dashboard").catch(() => {});
        })
        .catch(e => {
          const { data } = e;
          if (Object.prototype.hasOwnProperty.call(data, "message")) {
            this.error = true;
            this.error_message = data.message;
            this.password = "";
          }
        });
    },
    redirectForgot() {
      this.$router
        .push("/forgot-password")
        .catch(() => {});
    }
  }
};
</script>